// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, forwardRef } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { inject, observer } from "../../../../stores/mobx-compat";
import 'react-datepicker/dist/react-datepicker.css';
import '../Emails/datepicker-overrides.css';

import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import Alert from '../../../ui/Alert';
import Pill from '../../../ui/Pill';
import Empty from '../../../ui/Empty';
import Table, {
  Th, Td, Tr, TableToolbar, TablePager,
} from '../../../ui/Table';
import {
  RefreshIcon, MailIcon, ExternalLinkIcon, CalendarIcon, ChevronDownIcon,
} from '../../../ui/icons';

const EVENT_TYPES = [
  { value: 'delivered', label: 'Delivered', tone: 'blue' },
  { value: 'opened', label: 'Opened', tone: 'green' },
  { value: 'clicked', label: 'Clicked', tone: 'ink' },
  { value: 'spam', label: 'Spam', tone: 'red' },
  { value: 'unsubscribed', label: 'Unsubscribed', tone: 'amber' },
];
const TONE_BY_TYPE = EVENT_TYPES.reduce((m, e) => ({ ...m, [e.value]: e.tone }), {});
const PAGE_SIZE = 50;

class EmailActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().subtract(30, 'day').toDate(),
      endDate: new Date(),
      eventTypes: EVENT_TYPES.map((e) => e.value),
    };
  }

  componentDidMount() {
    this.fetch(1);
  }

  fetch = (page = 1) => {
    const { startDate, endDate, eventTypes } = this.state;
    this.props.store.analytics.getEmailEvents({
      startDate,
      endDate,
      eventTypes,
      page,
      pageSize: PAGE_SIZE,
    });
  }

  onRangeChange = ([start, end]) => this.setState({ startDate: start, endDate: end });

  setPreset = (days) => this.setState({
    startDate: moment().subtract(days, 'day').toDate(),
    endDate: new Date(),
  });

  toggleType = (value) => this.setState((s) => {
    const has = s.eventTypes.includes(value);
    const next = has ? s.eventTypes.filter((v) => v !== value) : [...s.eventTypes, value];
    return { eventTypes: next.length ? next : s.eventTypes };
  });

  render() {
    const { emailEvents, emailEventsPagination, loading } = this.props.store.analytics;
    const { startDate, endDate, eventTypes } = this.state;
    const busy = loading.getEmailEvents;

    return (
      <>
        <Alert tone="info" title="Email engagement activity">
          Every delivery, open, click, spam complaint, and unsubscribe from your recovery emails.
          Filter by date range and event type below.
        </Alert>

        <Card padded className="mt-5">
          <div className="flex items-center gap-2.5 flex-wrap">
            <div className="mov-rangepicker mov-rangepicker--pop">
              <DatePicker
                selectsRange
                showPopperArrow={false}
                startDate={startDate}
                endDate={endDate}
                onChange={this.onRangeChange}
                monthsShown={2}
                maxDate={new Date()}
                dateFormat="MM/dd/yyyy"
                popperPlacement="bottom-start"
                customInput={<RangeInput />}
              />
            </div>

            <span className="w-px h-5 bg-mov-line" aria-hidden="true" />

            <div className="flex items-center gap-1.5">
              <PresetChip label="7d" onClick={() => this.setPreset(7)} />
              <PresetChip label="30d" onClick={() => this.setPreset(30)} />
              <PresetChip label="90d" onClick={() => this.setPreset(90)} />
            </div>

            <span className="w-px h-5 bg-mov-line" aria-hidden="true" />

            <div className="flex items-center gap-1.5 flex-wrap">
              {EVENT_TYPES.map((e) => {
                const active = eventTypes.includes(e.value);
                return (
                  <button
                    key={e.value}
                    type="button"
                    onClick={() => this.toggleType(e.value)}
                    className="cursor-pointer transition-opacity"
                    style={{ background: 'transparent', border: 0, padding: 0, opacity: active ? 1 : 0.3 }}
                    aria-pressed={active}
                  >
                    <Pill tone={e.tone} dot>{e.label}</Pill>
                  </button>
                );
              })}
            </div>

            <Button
              variant="primary"
              icon={RefreshIcon}
              loading={busy}
              disabled={busy}
              onClick={() => this.fetch(1)}
              className="ml-auto"
            >
              Apply
            </Button>
          </div>
        </Card>

        <Card padded={false} className="mt-5">
          <TableToolbar title="Email events" count={emailEventsPagination.total} />
          {emailEvents.length === 0 && !busy ? (
            <Empty
              icon={MailIcon}
              title="No email activity"
              sub="No events match the selected date range and event types."
            />
          ) : (
            <>
              <Table>
                <thead>
                  <tr>
                    <Th>Email</Th>
                    <Th>Event</Th>
                    <Th>When</Th>
                    <Th>Page</Th>
                    <Th>Clicked URL</Th>
                  </tr>
                </thead>
                <tbody>
                  {emailEvents.map((ev, i) => (
                    <Tr key={`${ev.email}-${ev.event_type}-${ev.ts}-${i}`}>
                      <Td>{ev.email}</Td>
                      <Td>
                        <Pill tone={TONE_BY_TYPE[ev.event_type] || 'gray'} dot>
                          {ev.event_type}
                        </Pill>
                      </Td>
                      <Td mute>{moment(ev.ts).format('MMM DD, YYYY · HH:mm')}</Td>
                      <Td>
                        <span className="mov-mono text-[12px]" style={{ wordBreak: 'break-all' }}>
                          {ev.host}{ev.path}
                        </span>
                      </Td>
                      <Td>
                        {ev.clicked_url ? (
                          <a
                            href={ev.clicked_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1 text-mov-accent-ink underline"
                            style={{ wordBreak: 'break-all' }}
                          >
                            <ExternalLinkIcon size={12} className="shrink-0" />
                            {ev.clicked_url}
                          </a>
                        ) : <span className="text-mov-ink-mute">—</span>}
                      </Td>
                    </Tr>
                  ))}
                </tbody>
              </Table>
              <TablePager
                page={emailEventsPagination.page}
                totalPages={emailEventsPagination.totalPages}
                total={emailEventsPagination.total}
                onChange={(p) => this.fetch(p)}
              />
            </>
          )}
        </Card>
      </>
    );
  }
}

const RangeInput = forwardRef(({ value, onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    className="inline-flex items-center gap-2 text-[13px] cursor-pointer text-mov-ink"
    style={{
      background: 'var(--mov-paper)',
      border: '1px solid var(--mov-line-strong)',
      borderRadius: 9,
      padding: '8px 12px',
    }}
  >
    <CalendarIcon size={14} className="text-mov-ink-mute" />
    {value || 'Select date range'}
    <ChevronDownIcon size={12} className="text-mov-ink-mute" />
  </button>
));

const PresetChip = ({ label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="text-[12px] px-2.5 py-1 rounded-full border border-mov-line bg-mov-paper hover:border-mov-line-strong cursor-pointer text-mov-ink-soft hover:text-mov-ink transition-colors"
  >
    {label}
  </button>
);

export default inject('store')(observer(EmailActivity));
